import { Component, OnInit, ViewChild } from '@angular/core';
import { Proceso, Empresa } from '../../classes/coordinador';
import { isDefined } from '@angular/compiler/src/util';
import { AWSService } from '../../shared/services/aws.service';
import { ApiProcesosService } from 'src/app/shared/services/api-procesos.service';
import { ApiEmpresasService } from 'src/app/shared/services/api-empresas.service';
import { ArchivosConErrorPipe } from 'src/app/shared/pipes/archivosConError.pipe';
import { ApiDocumentosService } from 'src/app/shared/services/api-documentos.service';
import { FiltrosCargaComponent } from './filtros/filtros.component';
import { MatStepper, MatDialog } from '@angular/material';
import { AppStorage } from 'src/app/shared/services/appStorage.service';
import { ModalConfirmacionComponent } from 'src/app/shared/components/modal-confirmacion/modal-confirmacion.component';

@Component({
  selector: 'app-carga',
  templateUrl: './carga.component.html',
  styleUrls: ['./carga.component.css']
})
export class CargaComponent implements OnInit {
  @ViewChild(FiltrosCargaComponent)
  filtrosComponent: FiltrosCargaComponent;

  @ViewChild(MatStepper)
  stepper: MatStepper;

  constructor(
    private awsService: AWSService,
    public appStorage: AppStorage,
    private apiProcesosService: ApiProcesosService,
    private apiEmpresasService: ApiEmpresasService,
    private apiDocumentosService: ApiDocumentosService,
    public dialog: MatDialog,
    private archivosConErrorPipe: ArchivosConErrorPipe
  ) { }

  // loading
  loadingProcesoMes = false;
  loadingArchivosPublicados = false;
  loadingEmpresas = true;
  loadingProcesos = true;
  loadingCarpetaExiste = false;
  loadingSubirArchivos = false;
  loadingPublicarArchivos = false;
  loadingArchivosPendientes = false;
  loadingEliminarArchivo = false;

  // data
  archivos = [];
  archivosPendientes = [];

  // bloquear plazos maximos
  bloquearFechas: boolean;

  procesos: Proceso[];
  empresas: Empresa[];
  procesoAux;

  step = 'init';
  cargaArchivoEstado = 'init';
  cantidadArchivosConError = 0;
  error = false;

  ngOnInit() {
    this.cargarProcesos();
    this.cargarEmpresas();
  }

  currentStep() {
    switch (this.step) {
      case 'init':
        return 0;
      case 'noHayArchivosPendientes':
        return 1;
      case 'hayArchivosPendientes':
        return 1;
      case 'carga':
        return 1;
      case 'publicandoArchivos':
        return 2;
      case 'archivosPublicados':
        return 3;
      default:
        return -1;
    }
  }

  cargarProcesos() {
    this.loadingProcesos = true;
    this.apiProcesosService
      .getProcesosActivos()
      .then((res: any) => {
        this.procesos = res;
        this.procesos.sort(function (a, b) {
          if (a.sigla < b.sigla) {
            return -1;
          }
          if (a.sigla > b.sigla) {
            return 1;
          }
          return 0;
        });
        this.loadingProcesos = false;
      })
      .catch(error => {
        this.loadingProcesos = false;
      });
  }

  cargarEmpresas() {
    this.loadingEmpresas = true;
    this.apiEmpresasService
      .getEmpresas()
      .then((res: any) => {
        this.empresas = res;
        this.empresas = this.empresas.filter(item => item.sigla !== null);
        this.empresas.sort(function (a, b) {
          if (a.sigla < b.sigla) {
            return -1;
          }
          if (a.sigla > b.sigla) {
            return 1;
          }
          return 0;
        });
        this.loadingEmpresas = false;
      })
      .catch(error => {
        this.error = true;
        this.loadingEmpresas = false;
        console.error(error);
      });
  }

  volverACargar() {
    this.hayCambiosEnFiltro();
  }

  hayCambiosEnFiltro() {
    this.cargaArchivoEstado = 'init';
    this.cantidadArchivosConError = 0;
    this.archivos = [];

    if (this.filtrosSeleccionados()) {
      this.getProcesoMes();
    } else {
      this.step = 'init';
    }
  }

  getProcesoMes() {
    this.procesoAux = undefined;
    this.appStorage.loadingGeneral = true;
    this.apiProcesosService
      .getProcesoMes(
        this.filtrosComponent.filtrosSeleccionados.anno,
        this.filtrosComponent.filtrosSeleccionados.mes.numero,
        this.filtrosComponent.filtrosSeleccionados.proceso
      )
      .then((res: any) => {

        if (res) {
          this.procesoAux = res;
          this.filtrosComponent.cargarFechas(
            res.plazoMaxCoordinador,
            res.plazoMaxEmpresa,
            res.estado
          );
          this.bloquearFechas = true;

        } else {
          this.bloquearFechas = false;
          this.filtrosComponent.cargarFechas();
        }
        this.getArchivosPendientes();
        this.appStorage.loadingGeneral = false;
      })
      .catch(error => {
        this.appStorage.loadingGeneral = false;
      });
  }

  filtrosSeleccionados() {
    if (this.filtrosComponent) {
      return (
        isDefined(this.filtrosComponent.filtrosSeleccionados.anno) &&
        isDefined(this.filtrosComponent.filtrosSeleccionados.mes) &&
        isDefined(this.filtrosComponent.filtrosSeleccionados.proceso)
      );
    }

    return false;
  }

  // Sin archivos pendientes
  getArchivosPendientes() {
    this.loadingArchivosPendientes = true;
    this.apiDocumentosService
      .getDocumentosCargaCoordinador(
        this.filtrosComponent.filtrosSeleccionados.anno,
        this.filtrosComponent.filtrosSeleccionados.mes.numero,
        this.filtrosComponent.filtrosSeleccionados.proceso,
        'Pendiente'
      )
      .then((res: any) => {
        this.archivosPendientes = res;
        this.loadingArchivosPendientes = false;

        if (this.archivosPendientes && this.archivosPendientes.length > 0) {
          this.step = 'hayArchivosPendientes';
        } else {
          this.step = 'noHayArchivosPendientes';
        }
      })
      .catch(() => {
        this.loadingArchivosPendientes = false;
        this.step = 'error';
      });
  }

  dropped(event) {
    this.archivos = event.files;
    this.validarNombreArchivos();
  }

  validarNombreArchivos() {
    this.step = 'carga';

    this.cantidadArchivosConError = 0;

    for (const archivo of this.archivos) {
      if (this.nombreTieneError(archivo)) {
        this.cantidadArchivosConError++;
      }
    }

    if (this.cantidadArchivosConError === 0) {
      this.cargaArchivoEstado = 'ok';
      this.setVersionArchivos();
    } else if (this.cantidadArchivosConError === this.archivos.length) {
      this.cargaArchivoEstado = 'todosConError';
    } else {
      this.cargaArchivoEstado = 'algunosConError';
    }
  }

  nombreTieneError(archivo) {
    // sacar extension
    const nombreArchivo: string = archivo.relativePath;
    let nombreSinExtension = '';
    let extension = '';
    if (nombreArchivo.lastIndexOf('.') > 0) {
      nombreSinExtension = nombreArchivo.substr(
        0,
        nombreArchivo.lastIndexOf('.')
      );
      extension = nombreArchivo.substr(
        nombreArchivo.lastIndexOf('.') + 1,
        nombreArchivo.length - nombreArchivo.lastIndexOf('.')
      );
    } else {
      // archivo sin extension
      archivo.errorValidacion = true;
      return true;
    }

    // separar secciones
    const partesNombre = nombreSinExtension.split('_');

    if (partesNombre.length < 4) {
      // archivo con menor cantidad de secciones
      archivo.errorValidacion = true;
      return true;
    }

    // Validar version VC, VR y VM
    if (
      partesNombre[0].length < 2 ||
      (partesNombre[0].substr(0, 2) !== 'VC' &&
        partesNombre[0].substr(0, 2) !== 'VR' &&
        partesNombre[0].substr(0, 2) !== 'VM')
    ) {
      archivo.errorValidacion = true;
      return true;
    }

    // Validar FIFC
    if (partesNombre[1] !== 'FIFC') {
      archivo.errorValidacion = true;
      return true;
    }

    // Validar nombre empresa
    let existeEmpresa = false;
    let nombreEmpresa = partesNombre[2];

    for (let i = 3; i < partesNombre.length - 1; i++) {
      nombreEmpresa = nombreEmpresa + '_' + partesNombre[i];
    }

    for (const empresa of this.empresas) {
      if (empresa.sigla === nombreEmpresa) {
        existeEmpresa = true;
        archivo.idEmpresa = empresa.idEmpresa;
        break;
      }
    }

    if (!existeEmpresa) {
      archivo.errorValidacion = true;
      return true;
    }

    if (partesNombre[partesNombre.length - 1].length !== 11) {
      archivo.errorValidacion = true;
      return true;
    }

    // validar tipo proceso - sigla
    if (
      this.filtrosComponent.filtrosSeleccionados.proceso.sigla !==
      partesNombre[partesNombre.length - 1].substr(0, 4)
    ) {
      archivo.errorValidacion = true;
      return true;
    }

    // Validar mes
    if (
      this.filtrosComponent.filtrosSeleccionados.mes.sigla !==
      partesNombre[partesNombre.length - 1].substr(4, 3)
    ) {
      archivo.errorValidacion = true;
      return true;
    }

    // Validar anno
    if (
      this.filtrosComponent.filtrosSeleccionados.anno + '' !==
      partesNombre[partesNombre.length - 1].substr(7, 4)
    ) {
      archivo.errorValidacion = true;
      return true;
    }

    // Validar nombre repetido
    let count = 0;
    for (const archivoI of this.archivos) {
      if (
        nombreArchivo.substr(4, nombreArchivo.length) ===
        archivoI.relativePath.substr(4, archivoI.relativePath.length) &&
        nombreArchivo.substr(0, 2) === archivoI.relativePath.substr(0, 2)
      ) {
        count++;
      }
    }

    if (count > 1) {
      archivo.errorValidacion = true;
      return true;
    }

    return false;
  }

  eliminarArchivoPendiente(archivo) {
    this.loadingEliminarArchivo = true;

    this.awsService
      .eliminarArchivoTmp(
        this.filtrosComponent.filtrosSeleccionados.anno,
        this.filtrosComponent.filtrosSeleccionados.mes.sigla,
        this.filtrosComponent.filtrosSeleccionados.proceso,
        archivo
      )
      .then(() => {
        this.apiDocumentosService
          .eliminarDocumento(archivo.idDocumento)
          .then(() => {
            this.getArchivosPendientes();
            this.loadingEliminarArchivo = false;
          })
          .catch(errorRest => { });
      })
      .catch(error => {
        this.loadingEliminarArchivo = false;
      });
  }

  eliminarArchivosPendientes() {
    this.loadingEliminarArchivo = true;

    for (const archivo of this.archivosPendientes) {
      this.awsService
        .eliminarArchivoTmp(
          this.filtrosComponent.filtrosSeleccionados.anno,
          this.filtrosComponent.filtrosSeleccionados.mes.sigla,
          this.filtrosComponent.filtrosSeleccionados.proceso,
          archivo
        )
        .then(() => {
          this.apiDocumentosService
            .eliminarDocumento(archivo.idDocumento)
            .then(() => {
              archivo.eliminado = true;
              this.todosLosArchivosPendientesEliminados();
            })
            .catch(errorRest => { });
        })
        .catch(error => {
          this.loadingEliminarArchivo = false;
        });
    }
  }

  todosLosArchivosPendientesEliminados() {
    for (const archivo of this.archivos) {
      if (!archivo.eliminado) {
        return;
      }
    }
    this.archivosPendientes = [];
    this.step = 'init';
    this.hayCambiosEnFiltro();
    this.loadingEliminarArchivo = false;
  }

  eliminarArchivoConError(archivo) {
    this.archivos.splice(this.archivos.indexOf(archivo), 1);
    this.validarNombreArchivos();
  }

  eliminarArchivosConErrores() {
    this.archivos = this.archivos.filter(archivo => !this.nombreTieneError(archivo));
    this.validarNombreArchivos();
    // this.volverACargar();
  }

  setVersionArchivos() {
    this.loadingArchivosPublicados = true;
    this.apiDocumentosService
      .getDocumentosCargaCoordinador(
        this.filtrosComponent.filtrosSeleccionados.anno,
        this.filtrosComponent.filtrosSeleccionados.mes.numero,
        this.filtrosComponent.filtrosSeleccionados.proceso,
        'Publicado'
      )
      .then((res: any) => {
        if (res === null) {
          for (const archivo of this.archivos) {
            archivo.nombreASubir =
              archivo.relativePath.substr(0, 2) +
              '01' +
              archivo.relativePath.substr(4, archivo.relativePath.length);
          }
        } else {
          for (const archivo of this.archivos) {
            for (const archivoPublicado of res) {
              let archivoExiste = false;
              if (
                archivo.relativePath.substr(0, 2) ===
                archivoPublicado.nombreArchivo.substr(0, 2) &&
                archivo.relativePath.substr(4, archivo.relativePath.length) ===
                archivoPublicado.nombreArchivo.substr(
                  4,
                  archivoPublicado.nombreArchivo.length
                )
              ) {
                archivoExiste = true;
                const versionMasAlta = parseInt(
                  archivoPublicado.version.substr(2),
                  0
                );

                if (versionMasAlta < 9) {
                  archivo.nombreASubir =
                    archivo.relativePath.substr(0, 2) +
                    '0' +
                    (versionMasAlta + 1) +
                    archivo.relativePath.substr(4, archivo.relativePath.length);
                } else {
                  archivo.nombreASubir =
                    archivo.relativePath.substr(0, 2) +
                    (versionMasAlta + 1) +
                    archivo.relativePath.substr(4, archivo.relativePath.length);
                }
                break;
              }

              if (!archivoExiste) {
                archivo.nombreASubir =
                  archivo.relativePath.substr(0, 2) +
                  '01' +
                  archivo.relativePath.substr(4, archivo.relativePath.length);
              }
            }
          }
        }

        this.loadingArchivosPublicados = false;
      })
      .catch(error => {
        this.step = 'error';
        this.loadingArchivosPublicados = false;
      });
  }

  clickSubirArchivos() {
    this.loadingSubirArchivos = true;
    this.subirArchivos();
  }

  subirArchivos() {
    for (const archivo of this.archivos) {
      // Subir archivo a S3
      this.awsService
        .subirArchivo(
          archivo,
          this.filtrosComponent.filtrosSeleccionados.anno,
          this.filtrosComponent.filtrosSeleccionados.mes.sigla,
          this.filtrosComponent.filtrosSeleccionados.proceso.sigla
        )
        .then((res: any) => {
          archivo.url = res.location;
          this.subirArchivoTmp();
        })
        .catch(error => {
          this.loadingSubirArchivos = false;

          console.log(error);
        });
    }
  }

  subirArchivoTmp() {
    let count = 0;

    for (const archivo of this.archivos) {
      if (!archivo.url) {
        break;
      } else {
        count++;
      }
    }

    if (count === this.archivos.length) {
      // Registrar subida en bd
      this.apiDocumentosService
        .subirDocumentoTmp(
          this.archivos,
          this.filtrosComponent.filtrosSeleccionados.anno,
          this.filtrosComponent.filtrosSeleccionados.mes.numero,
          this.filtrosComponent.filtrosSeleccionados.plazoCargaCoordinador,
          this.filtrosComponent.filtrosSeleccionados.proceso
        )
        .then(resRest => {
          this.loadingSubirArchivos = false;
          this.archivos = [];
          this.getArchivosPendientes();
        });
    }
  }

  // FIN sin archivos pendientes

  // Publicar archivos
  abrirInformativoPublicar() {
    const dialogRef = this.dialog.open(ModalConfirmacionComponent, {
      width: '350px',
      data: {
        ocultarCancelar: true,
        icon: 'error_outline',
        texto:
          'Estimado usuario. Existen archivos ya publicados con el mismo nombre, a los cuales se les ha aumentado la versión',
        textoBoton: 'Aceptar',
        callback: () => {
          dialogRef.close();
        }
      }
    });

    return dialogRef;
  }

  clickPublicarArchivos() {
    this.loadingPublicarArchivos = true;
    this.step = 'publicandoArchivos';
    for (const archivo of this.archivosPendientes) {
      this.publicarArchivoAWS(archivo);
    }
  }

  publicarArchivoAWS(archivo) {
    this.awsService
      .moverArchivoTempAProcesos(
        archivo,
        this.filtrosComponent.filtrosSeleccionados.anno,
        this.filtrosComponent.filtrosSeleccionados.mes.sigla,
        this.filtrosComponent.filtrosSeleccionados.proceso.sigla
      )
      .then(() => {
        archivo.publicado = true;
        this.terminarPublicar();
      })
      .catch(error => {
        this.loadingPublicarArchivos = false;
      });
  }

  terminarPublicar() {
    let count = 0;
    for (const archivo of this.archivosPendientes) {
      if (!archivo.publicado) {
        break;
      } else {
        count++;
      }
    }

    if (count === this.archivosPendientes.length) {
      this.awsService
        .eliminarArchivosTmp(
          this.filtrosComponent.filtrosSeleccionados.anno,
          this.filtrosComponent.filtrosSeleccionados.mes.sigla,
          this.filtrosComponent.filtrosSeleccionados.proceso.sigla
        )
        .then(() => {
          this.publicarArchivosRest();
        })
        .catch(errorEliminar => {
          this.loadingPublicarArchivos = false;
        });
    }
  }

  publicarArchivosRest() {
    this.loadingPublicarArchivos = true;
    this.apiDocumentosService
      .publicarDocumentosCoordinador(
        this.filtrosComponent.filtrosSeleccionados.anno,
        this.filtrosComponent.filtrosSeleccionados.mes.numero,
        this.filtrosComponent.filtrosSeleccionados.proceso,
        this.filtrosComponent.filtrosSeleccionados.plazoCargaEmpresa,
        this.filtrosComponent.filtrosSeleccionados.plazoCargaCoordinador
      )
      .then(res => {
        this.step = 'archivosPublicados';

        let archivoYaSubido = false;
        for (const archivo of this.archivosPendientes) {
          if (archivo.version.indexOf('01') < 0) {
            archivoYaSubido = true;
            break;
          }
        }

        if (archivoYaSubido) {
          this.abrirInformativoPublicar();
        }

        this.loadingPublicarArchivos = false;
      })
      .catch(error => { });
  }
  // Fin Publicar archivos
}
